import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { gameList } from "@/mocks/games";

export default function GameSection() {
  const items = gameList.slice(0, 6);

  return (
    <section>
      <SectionHeading
        icon="ri-gamepad-line"
        title="游戏攻略热文"
        desc="热门游戏实用攻略，助你快速上手与进阶"
        actionTo="/game"
        actionLabel="全部攻略"
      />

      <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
        {items.map((game, index) => (
          <Link
            key={game.id}
            to={`/detail/${game.id}`}
            className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-50 md:px-5"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                index < 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                {game.title}
              </h3>
              <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-400">
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">
                  {game.gameType}
                </span>
                <span className="rounded bg-background-200 px-2 py-0.5 text-foreground-600">
                  {game.platform}
                </span>
                <span className="hidden sm:inline">{game.date}</span>
              </div>
            </div>
            <i
              className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-300 transition-colors group-hover:text-primary-500"
              aria-hidden="true"
            ></i>
          </Link>
        ))}
      </div>
    </section>
  );
}